<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-29 10:13:32
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\antiFake\fleeWarning\components\detail.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="70%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>查看</div>
      <div>
        <el-button @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <el-form ref="form" label-width="100px" label-suffix="：">
        <div class="box-title">产品信息</div>
        <div class="gird-container">
          <el-form-item label="产品UDI码">
            <div class="form-content" :title="detialInfo.code">{{ detialInfo.code }}</div>
          </el-form-item>
          <el-form-item label="产品名称">
            <div class="form-content" :title="detialInfo.appletUdiProductInfoVo.productName">{{
              detialInfo.appletUdiProductInfoVo.productName }}</div>
          </el-form-item>
          <el-form-item label="规格型号">
            <div class="form-content" :title="detialInfo.appletUdiProductInfoVo.specifiction">{{
              detialInfo.appletUdiProductInfoVo.specifiction }}</div>
          </el-form-item>
          <el-form-item v-for="(item, index) in detialInfo.codeInfoVoList" :key="index" :label="item.aidName">
            <div class="form-content" :title="item.aidContent">{{ item.aidContent }}</div>
          </el-form-item>
        </div>

        <div class="box-title">扫码信息</div>
        <div class="gird-container">
          <el-form-item label="客户名称">
            <div class="form-content" :title="detialInfo.deliveryInfoVo.customer">{{ detialInfo.deliveryInfoVo.customer }}
            </div>
          </el-form-item>
          <el-form-item label="出库单编号">
            <div class="form-content" :title="detialInfo.deliveryInfoVo.bizId">{{ detialInfo.deliveryInfoVo.bizId }}</div>
          </el-form-item>
          <el-form-item label="收件人名称">
            <div class="form-content" :title="detialInfo.deliveryInfoVo.receiveName">{{
              detialInfo.deliveryInfoVo.receiveName }}</div>
          </el-form-item>
          <el-form-item label="出库地区">
            <div class="form-content">
              {{ area }}
            </div>
          </el-form-item>
          <el-form-item label="扫码地区">
            <div class="form-content" :title="detialInfo.appletAntifakeRecordVo.scanArea">{{
              detialInfo.appletAntifakeRecordVo.scanArea }}</div>
          </el-form-item>

          <el-form-item label="状态">
            <div class="form-content" :title="detialInfo.appletAntifakeRecordVo.specifiction">
              {{ detialInfo.appletAntifakeRecordVo.recordStatus | formatStatus(detialInfo.roleType) }}
            </div>
          </el-form-item>
          <el-form-item label="扫码角色">
            <div class="form-content" :title="detialInfo.appletAntifakeRecordVo.roleType">
              {{ detialInfo.roleType | formatRole(detialInfo.opName) }}
            </div>
          </el-form-item>
          <el-form-item label="扫码时间">
            <div class="form-content" :title="detialInfo.appletAntifakeRecordVo.scanTime">
              {{ detialInfo.appletAntifakeRecordVo.scanTime ? parseTime(detialInfo.appletAntifakeRecordVo.scanTime) :
                null }}
            </div>
          </el-form-item>
        </div>
        <div class="box-title">处理信息</div>
        <div class="gird-container">
          <el-form-item label="处理状态">
            <div class="form-content" :title="detialInfo.appletAntifakeRecordVo.handleStatus">
              <dict-tag :options="dictObj.handle_status" :value="detialInfo.appletAntifakeRecordVo.handleStatus" />
            </div>
          </el-form-item>
          <el-form-item label="处理方案">
            <div class="form-content" :title="detialInfo.appletAntifakeRecordVo.handleWay">
              <dict-tag :options="dictObj.handle_way" :value="detialInfo.appletAntifakeRecordVo.handleWay" />
            </div>
          </el-form-item>
          <el-form-item label="处理时间">
            <div class="form-content">
              {{ detialInfo.appletAntifakeRecordVo.handleTime ? parseTime(detialInfo.appletAntifakeRecordVo.handleTime) :
                null
              }}
            </div>
          </el-form-item>
          <el-form-item label="处理人">
            <div class="form-content" :title="detialInfo.appletAntifakeRecordVo.handleUser">
              {{ detialInfo.appletAntifakeRecordVo.handleUser }}
            </div>
          </el-form-item>
          <el-form-item label="备注">
            <div class="form-content" :title="detialInfo.appletAntifakeRecordVo.handleRemark">
              {{ detialInfo.appletAntifakeRecordVo.handleRemark }}
            </div>
          </el-form-item>
        </div>

      </el-form>
    </el-card>
  </el-drawer>
</template>

<script>
import { getFleeWarning } from '@/api/antiFake/fleeWarning'
export default {
  name: 'DetialInventory',
  filters: {
    formatStatus(value, roleType) {
      if (roleType === '1') {
        return "疑似窜货"
      }
      if (value) {
        return value === 'suspected_cross_shipped' ? "疑似窜货" : "未窜货"
      }
      return ''
    },
    formatRole(value, opName) {
      if (value === '0') {
        return `监管员-${opName}`
      }
      return '普通用户'
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    fleeWarningInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    dictObj: {
      type: Object,
      default() {
        return {
          handle_way: [],
          handle_status: []
        }
      }
    }
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      detialInfo: {
        appletUdiProductInfoVo: {},
        appletAntifakeRecordVo: {},
        deliveryInfoVo: {},
        codeInfoVoList: [],
      },
    }
  },
  computed: {
    area() {
      if (!this.detialInfo.appletAntifakeRecordVo) {
        return ''
      }
      const { deliveryProvinceName = '', deliveryCityName = '', deliveryCountyName = '' } = this.detialInfo.appletAntifakeRecordVo
      return `${deliveryProvinceName}${deliveryCityName}${deliveryCountyName}`
    }
  },
  created() {
    if (this.fleeWarningInfo.id) {
      this.getDetial()
    }
  },
  // 方法集合
  methods: {
    getDetial() {
      this.loading = true
      getFleeWarning({ id: this.fleeWarningInfo.id }).then((res) => {
        this.$set(this, 'detialInfo', res.data)
        console.log(this.detialInfo);
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style>
.form-content {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
